import { Box, Flex } from "@chakra-ui/react";
import React from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "../../../icons";
import {
  dateToYYYYMMDD,
  formatDateDDMMYYYY,
  monthFullNames,
} from "../../../utils/dates";
import { Button } from "../../common";
import { useVeriDatePicker } from "../VeriDatePickerContext";
import { VeriDatePickerView } from "../VeriDatePickerContext/VeriDatePickerContext.types";
import { VeriDatePickerHeaderProps } from "./VeriDatePickerHeader.types";
import { selectedDateConsideringNegativeTimezoneOffset } from "../utils";

const VeriDatePickerHeader: React.FC<VeriDatePickerHeaderProps> = ({
  ...rest
}) => {
  const datePicker = useVeriDatePicker();

  const date = selectedDateConsideringNegativeTimezoneOffset(
    datePicker.dateString,
  );

  const month = date.getMonth();
  const year = date.getFullYear();

  const isMonthYearsView =
    datePicker.view === VeriDatePickerView.YearsAndMonths;

  const onToday = () => {
    datePicker.setDate(new Date());
  };

  const onChange = (isBackward: boolean) => () => {
    const lastItem = isBackward ? 0 : 11;
    const itemsToAdd = isBackward ? -1 : 1;

    if (isMonthYearsView) {
      datePicker.changeState("yearStep", datePicker.yearStep + itemsToAdd);
      return;
    }

    const _date = new Date(date);

    if (month === lastItem) {
      _date.setFullYear(year + itemsToAdd, Math.abs(11 - month));
    } else {
      _date.setMonth(month + itemsToAdd);
    }

    /*datePicker.changeState(
      "selectedDate",
      new Date(datePicker.selectedDate?.toDateString() || ""),
    );*/

    //datePicker.changeState("date", new Date(_date));
    datePicker.changeState("dateString", dateToYYYYMMDD(new Date(_date)));
  };

  const onYearChange = () => {
    if (datePicker.isRangePicker) return;

    setTimeout(() => {
      datePicker.changeState(
        "view",
        datePicker.view === VeriDatePickerView.YearsAndMonths
          ? VeriDatePickerView.Days
          : VeriDatePickerView.YearsAndMonths,
      );
    }, 5);
  };

  const monthName = monthFullNames[date.getMonth()];

  return (
    <Flex my={2} alignItems="center" {...rest}>
      <Box>
        <Button onClick={onChange(true)} outline>
          <ChevronLeftIcon />
        </Button>
      </Box>
      <Box ml={1}>
        <Button
          isDisabled={!datePicker.isDateEnabled(new Date())}
          onClick={onToday}
          outline
        >
          Today
        </Button>
      </Box>
      <Flex
        flex="1"
        justifyContent="center"
        alignItems={"center"}
        flexDir={"column"}
        fontWeight="bold"
        fontSize="large"
        userSelect="none"
        _hover={{ cursor: "pointer" }}
        onClick={onYearChange}
      >
        {!isMonthYearsView ? (
          <Box>
            {monthName} {year}
          </Box>
        ) : undefined}
        {isMonthYearsView && datePicker.selectedDate ? (
          <Box>
            {formatDateDDMMYYYY(
              new Date(datePicker.selectedDateString || new Date()),
            )}
          </Box>
        ) : undefined}
      </Flex>
      <Box>
        <Button onClick={onChange(false)} outline>
          <ChevronRightIcon />
        </Button>
      </Box>
    </Flex>
  );
};

export default VeriDatePickerHeader;
